import createRouter from 'router5';
import browserPlugin from 'router5-plugin-browser';

import routes, {ROUTES} from './routes';

export default function configureRouter() {
    const router = createRouter(routes, {
        defaultRoute: ROUTES.CAMERAS,
    });

    router.usePlugin(browserPlugin());

    return router
}
